import React from 'react'

import SkeletonTableRows from '@/components/skeleton/SkeletonTableRows'
import { Table, TableBody } from '@/components/ui/table'
import { cn } from '@/lib/utils'

type Props = React.ComponentProps<typeof SkeletonTableRows> &
  React.ComponentProps<'table'>

const SkeletonTable: React.FC<Props> = ({
  rows,
  columns,
  columnWidth,
  className,
  ...props
}) => {
  return (
    <Table {...props} className={cn('bg-white p-2', className)}>
      <TableBody>
        <SkeletonTableRows
          rows={rows}
          columns={columns}
          columnWidth={columnWidth}
        />
      </TableBody>
    </Table>
  )
}

export default SkeletonTable
